import React from 'react';
import { RobotOutlined } from '@ant-design/icons';

export enum ErrorSize {
	small = 'small',
	medium = '',
	large = 'large'
}

interface IProps {
	message?: string,
	errorSize?: ErrorSize,
	outerContainerClass?: string,
	innerContainerClass?: string
}

export function ErrorMessage(props: IProps) {

	const message = props.message ? props.message : 'Oops, something went wrong. Please try again later.';

	return (
		<div className={`${props.outerContainerClass} ${props.errorSize?.toString()} error-message-container`}>
			<div className={`${props.innerContainerClass} txt-center`}>
				<RobotOutlined />
				<p className="error-message">{message}</p>
			</div>
		</div>
	);
};

export function LargeErrorMessage(props: { message?: string }) {
	return <ErrorMessage
		message={props.message}
		errorSize={ErrorSize.large}
		outerContainerClass="pos-rel h-vh-90"
		innerContainerClass="pos-abs-center"
	/>;
}